import { clearStoragePreservingLanguage } from '@/utils/i18n/languageManager';
/** Expiração de login não pode apagar uma cobrança cujo resultado é desconhecido. */
export function clearAuthStorage() {
  const pendingPayments = Object.keys(sessionStorage)
    .filter(key => key.startsWith('hostvsl:subscription-checkout:') || key.startsWith('hostvsl:surplus-purchase:'))
    .map(key => [key, sessionStorage.getItem(key)] as const);
  clearStoragePreservingLanguage();
  sessionStorage.clear();
  pendingPayments.forEach(([key, value]) => { if (value) sessionStorage.setItem(key, value); });
}
